<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="Grade Entry">
      <v-card flat class="px-2">
        <v-row>
          <v-col cols="12" md="6" lg="3">
            <span class="body-2 font-weight-medium"> Class <span class="error--text">*</span> </span>
            <v-autocomplete
              class="my-0 py-1"
              placeholder="--Select--"
              name="classSelect"
              v-model="selectedClassID"
              required
              @change="changeSections()"
              item-value="id"
              item-text="name"
              :items="classes"
              key="id"
            >
            </v-autocomplete>
          </v-col>
          <!-- :v-bind="class1.id" -->
          <v-col cols="12" md="6" lg="3">
            <span class="body-2 font-weight-medium"> Section <span class="error--text">*</span> </span>
            <v-autocomplete
              class="my-0 py-1"
              placeholder="--Select--"
              name="sectionSelect"
              v-model="selectedSectionID"
              required
              @change="getSkills()"
              item-value="id"
              item-text="name"
              :items="classWiseSections"
              key="id"
            >
            </v-autocomplete>
          </v-col>
          <!-- :v-bind="sectn.id" -->
          <v-col cols="12" md="6">
            <span class="body-2 font-weight-medium"> Skills <span class="error--text">*</span> </span>
            <v-autocomplete class="my-0 py-1" placeholder="--Select--" v-model="selectedSkill" required @change="getSubSkills()" item-value="id" item-text="name" :items="skills" key="id">
            </v-autocomplete>
          </v-col>
          <!-- :v-bind="skill.id" -->
          <v-col cols="12" md="6" lg="3">
            <span class="body-2 font-weight-medium"> Sub Skills <span class="error--text">*</span> </span>
            <v-autocomplete class="my-0 py-1" placeholder="--Select--" v-model="selectedSubSkill" required @change="getTerms()" item-value="id" :items="subSkills" key="id" item-text="name">
            </v-autocomplete>
          </v-col>
          <!-- :v-bind="subSkill.id" -->

          <v-col cols="12" md="6" lg="3">
            <span class="body-2 font-weight-medium"> Term <span class="error--text">*</span> </span>
            <v-autocomplete class="my-0 py-1" placeholder="--Select--" v-model="selectedTerm" required item-value="id" :items="terms" item-text="customName" key="academicTerm.id"> </v-autocomplete>
          </v-col>
          <!-- :v-bind="term.academicTerm.id" -->
          <v-col cols="12" md="6" lg="3">
            <span class="body-2 font-weight-medium"> Action </span>
            <div class="inside">
              <v-btn color="success" elevation="1" @click="getData()"><v-icon left>mdi-magnify</v-icon>Search</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card>
      <v-card-component>
        <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
          <v-card-title>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-text-field
            :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto mb-2"
            label="Search"
            hide-details
            single-line
            style="max-width:350px;"
          />
          <v-btn v-if="isWrite" elevation="1" @click="save" :class="{ 'mt-2': $vuetify.breakpoint.xs }" color="primary">
            <v-icon left>mdi-content-save</v-icon>
            save
          </v-btn>
        </v-card-text>
        <v-divider class="my-0 py-0"></v-divider>
        <v-data-table :headers="headers" :items="tableData" :search="search" disable-pagination hide-default-footer>
          <template v-slot:body="props">
            <tr v-for="item in props.items" :key="item.id">
              <td v-for="(header, index) in headers" :key="index">
                <span v-if="index == 0">
                  <span class="text-capitalize">{{ item.studentEnrollment.studentName }}</span>
                </span>
                <span v-else>
                  <v-autocomplete style="max-width:300px;" label="Scale*" class="d-flex justify-center" placeholder="--Select--" v-model="item[header.value]" required item-value="id" :items="scaleList" item-text="name" key="id"> </v-autocomplete>
                </span>
              </td>
            </tr>
          </template>

          <template v-slot:no-data>
            <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
          </template>
        </v-data-table>
      </v-card-component>
    </material-card>
    <loading-icon :value="isLoading" />
  </v-container>
</template>
<script>
import constants from '@/utils/constants'
import { mapGetters } from 'vuex'
import Utils from '@/utils'
import _ from 'lodash'
import moment from 'moment'
import VCardComponent from '@/components/template/VCardComponent'
import MaterialCard from '@/components/template/MaterialCard'

export default {
  components: { VCardComponent, MaterialCard },
  data () {
    return {
      selecte: [],
      search: '',
      classes: [],
      total: 0,
      selectedClassID: '',
      academicYearID: '',
      academicYears: [],
      selectedSkill: '',
      skills: [],
      selectedTerm: '',
      terms: [],
      subSkills: [],
      selectedSubSkill: '',
      tableData: [],
      isLoading: false,
      parameters: [],
      scaleList: [],
      isWrite: false,
      sections: [],
      selectedSectionID: '',
      classWiseSections: [],
      headers: [],
      inProgress: false,
      termAcademicId: Number,
      selectedClasses: []
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
    },
    selectedClassID () {
      this.tableData = []
      this.headers = []
      this.selectedSkill = ''
      this.selectedSubSkill = ''
      this.selectedTerm = ''
      this.selectedSectionID = ''
    },
    selectedSectionID () {
      this.tableData = []
      this.headers = []
    },
    selectedSkill () {
      this.tableData = []
      this.selectedSubSkill = ''
      this.headers = []
    },
    selectedSubSkill () {
      this.tableData = []
      this.headers = []
    },
    selectedTerm () {
      this.termAcademicId = null
      this.tableData = []
      this.terms.map(a => {
        if (a.id === this.selectedTerm) {
          this.termAcademicId = a.academicTerm.id
        }
      })
    }
  },
  async created () {
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    await this.getScales()
    await this.onFranchiseeChange()
  },
  methods: {
    save: async function () {
      if (!this.franchiseeID) {
        this.errMsg('Kindly select Franchisee!')
        return false
      } else if (!this.academicYearID) {
        this.errMsg('Kindly select Academic Year!')
        return false
      } else if (!this.selectedClassID) {
        this.errMsg('Kindly select Class!')
        return false
      } else if (!this.selectedSectionID) {
        this.errMsg('Kinldy select Section!')
        return false
      } else if (!this.selectedSkill) {
        this.errMsg('Kinldy select Skill!')
        return false
      } else if (!this.selectedSubSkill) {
        this.errMsg('Kinldy select Sub skill!')
        return false
      } else if (!this.selectedTerm) {
        this.errMsg('Kinldy select Term!')
        return false
      }
      try {
        this.isLoading = true

        var final = []

        this.tableData.forEach(student => {
          this.parameters.forEach(param => {
            if (student[param.id]) {
              final.push({
                studentAdmissionsID: student.id,
                gradeParameterID: param.id,
                gradeScaleID: student[param.id] || null,
                description: param.name,
                isActive: true
              })
            }
          })
        })

        if (final.length <= 0) {
          this.errMsg('Kindly select atleast one value!')
          return false
        }

        let formData = {
          franchiseeID: this.franchiseeID,
          classID: this.selectedClassID,
          sectionID: this.selectedSectionID,
          academicTermsDateMapID: this.selectedTerm,
          gradeSkillID: this.selectedSkill,
          gradeSubSkillID: this.selectedSubSkill,
          gradeMaps: final
        }

        await http.post(`${constants.API_URL}/api/grade-module/grade-map`, formData)
        this.okMsg('Record added successfully!!')
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
        this.getData()
      }
    },
    getData: async function () {
      this.total = 0
      this.tableData = []
      this.headers = []
      if (!this.franchiseeID) {
        this.errMsg('Kindly select Franchisee!')
        return false
      } else if (!this.academicYearID) {
        this.errMsg('Kindly select Academic Year!')
        return false
      } else if (!this.selectedClassID) {
        this.errMsg('Kindly select Class!')
        return false
      } else if (!this.selectedSectionID) {
        this.errMsg('Kinldy select Section!')
        return false
      } else if (!this.selectedSkill) {
        this.errMsg('Kinldy select Skill!')
        return false
      } else if (!this.selectedSubSkill) {
        this.errMsg('Kinldy select Sub skill!')
        return false
      } else if (!this.selectedTerm) {
        this.errMsg('Kinldy select Term!')
        return false
      }

      await this.getparameters()
      try {
        this.isLoading = true

        const response = await http.get(
          `${constants.API_URL}/api/grade-module/grade-map/skills?classID=${this.selectedClassID}&&gradeSkillID=${this.selectedSkill}&&gradeSubSkillID=${this.selectedSubSkill}&&academicTermsDateMapID=${this.selectedTerm}&&franchiseeID=${this.franchiseeID}&&academicYearID=${this.academicYearID}&&sectionID=${this.selectedSectionID}`
        )
        const data = response.data
        // if (data.length === 0) {
        //   this.errMsg("First, kindly assign subskill's to students!")
        // } else {
        this.tableData = data
        if (this.parameters.length > 0) {
          this.tableData.forEach(student => {
            this.parameters.forEach(param => {
              const gradeScale = _.find(student.gradeMaps, item => _.isEqual(item.gradeParameterID, param.id))
              student[param.id] = gradeScale ? gradeScale.gradeScaleID : null
            })
          })
        }

        // }

        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getparameters: async function () {
      if (this.selectedSkill === '') {
        this.errMsg('Kinldy select Skill!')
        return false
      } else if (this.selectedSubSkill === '') {
        this.errMsg('Kinldy select Sub skill!')
        return false
      }
      try {
        const { data } = await http.get(`${constants.API_URL}/api/grade-module/parameter/skills?gradeSkillID=${this.selectedSkill}&&gradeSubSkillID=${this.selectedSubSkill}&&academicTermID=${this.termAcademicId}`)
        this.parameters = data
        if (this.parameters.length > 0) {
          this.headers.push({ text: 'Name', sortable: false, value: 'studentEnrollment.studentName' })
        } else {
          this.errMsg('No record found!')
          return false
        }

        this.parameters.forEach(element => {
          this.headers.push({ text: element.name.trim(), sortable: false, value: element.id })
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getSkills: async function () {
      if (this.selectedClassID === '') {
        this.errMsg('Kindly select Class!')
        return false
      }
      if (this.academicYearID === '') {
        this.errMsg('Kindly select Academic Year!')
        return false
      }

      try {
        this.isLoading = true
        this.selectedClasses.push(this.selectedClassID)
        let formData = {
          classID: this.selectedClasses,
          academicYearID: this.academicYearID
        }
        const { data } = await http.post(`${constants.API_URL}/api/v1/grade-module/skill`, formData)
        // const { data } = await http.get(`${constants.API_URL}/api/grade-module/skill?classID=${this.selectedClassID}&&academicYearID=${this.academicYearID}`)
        // this.skills = data.length > 0 ? data[0].gradeSkills : []
        // New api to fetch GradeSkills list with respect to AcademicYear, Class and Section
        // const { data } = await http.get(`${constants.API_URL}/api/grade-module/classSectionSkill?classID=${this.selectedClassID}&&academicYearID=${this.academicYearID}&&sectionID=${this.selectedSectionID}`)
        this.skills = data
        this.isLoading = false
      } catch (e) {
        this.isLoading = false

        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getScales: async function () {
      try {
        this.isLoading = true
        let { data } = await http.get(`${constants.API_URL}/api/grade-module/grade-scale`)
        this.scaleList = data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getClassList: async function () {
      try {
        this.isLoading = true

        let response = await http.get(`${constants.API_URL}/api/student/all-count?franchiseeID=${this.franchiseeID}&&academicYearID=${this.academicYearID}&&isAllValue=true`)
        const data = response.data
        this.classes = data
        this.sections = data.map(obj => {
          return {
            id: obj.id,
            sections: obj.studentSections
          }
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    changeSections: async function () {
      let sectionarray = this.sections.find(obj => obj.id === this.selectedClassID)
      if (sectionarray) {
        this.classWiseSections = sectionarray.sections
      } else {
        this.classWiseSections = []
      }
    },
    getTerms: async function () {
      if (!this.franchiseeID) {
        this.errMsg('Kindly select Franchisee!')
        this.terms = []
        this.selectedTerm = ''
        this.tableData = []
        return false
      } else if (!this.academicYearID) {
        this.errMsg('Kindly select Academic Year!')
        this.terms = []
        this.selectedTerm = ''
        this.tableData = []

        return false
      } else if (!this.selectedClassID) {
        this.errMsg('Kindly select Class!')
        this.terms = []
        this.selectedTerm = ''
        this.tableData = []

        return false
      }

      try {
        this.isLoading = true

        const { data } = await http.get(
          `${constants.API_URL}/api/grade-module/academic-terms/date/map?classID=${this.selectedClassID}&&franchiseeID=${this.franchiseeID}&&academicYearID=${this.academicYearID}`
        )
        this.terms = data
        let t = this.terms.map(a => {
          a.toDate = moment(a.toDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
          a.fromDate = moment(a.fromDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
          a.customName = `${a.academicTerm.name} (${a.toDate}/${a.fromDate})`
          return a
        })
        this.terms = t
        this.isLoading = false
      } catch (e) {
        this.isLoading = false

        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getSubSkills: async function () {
      if (this.selectedSkill === '') {
        this.errMsg('Kinldy select Skill!')
        return false
      }
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/grade-module/sub-skill?gradeSkillID=${this.selectedSkill}`)
        // this.subskills = data.length > 0 ? data[0].gradeSubSkills : []
        this.subSkills = data.length > 0 ? data[0].gradeSubSkills : []
        // this.total = this.subskills.length
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting Data: ${errorMessage}`)
      }
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }

        this.selectedTerm = ''
        if (this.franchiseeID && this.academicYearID) {
          await this.getClassList()
        }
        if (this.selectedClassID && this.franchiseeID && this.academicYearID) {
          await this.getTerms()
        }
        this.inProgress = false
      }
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
<style scoped>
.to-bottom {
  align-self: flex-end;
}
</style>
